import { FieldBase } from '@/components/form';
import { useAnlageassistentFormContext } from '@/domain/mitarbeiter/features/anlageassistent/context/AnlageassistentFormContext';
import { useAnlageassistentContext } from '@/domain/mitarbeiter/features/anlageassistent/context/useAnlageassistentContext';
import { Toggle } from '@e2n/ui';
import { useTranslation } from 'react-i18next';

export function RichtwertEinheit() {
  const { t } = useTranslation();
  const form = useAnlageassistentFormContext();
  const { ctx } = useAnlageassistentContext();
  return (
    <div className="flex flex-col gap-4">
      <div className="flex gap-1 items-center">
        <span className="text-neutrals-900 text-xl font-bold leading-7">
          {t(
            'domain.mitarbeiter.create.steps.bezahlung.sollstunden.form.richtwertEinheit.description',
          )}
        </span>
      </div>
      <form.AppField
        name="bezahlung.arbeitszeitkonto.stundenloehner.richtwertEinheit"
        listeners={{
          onChange: () => {
            ctx.resetDependentFields(
              'bezahlung.arbeitszeitkonto.stundenloehner.richtwertEinheit',
            );
          },
        }}>
        {(field) => (
          <FieldBase>
            <div className="flex items-start gap-4">
              <Toggle
                pressed={field.state.value === 'euro'}
                onPressedChange={() => field.handleChange('euro')}
                variant={'outline'}
                className="flex items-center justify-start gap-2 p-4 h-auto">
                <span>
                  {t(
                    'domain.mitarbeiter.create.steps.bezahlung.sollstunden.form.richtwertEinheit.options.euro',
                  )}
                </span>
              </Toggle>
              <Toggle
                pressed={field.state.value === 'stunden'}
                onPressedChange={() => field.handleChange('stunden')}
                variant={'outline'}
                className="flex items-center justify-start gap-2 p-4 h-auto">
                <span>
                  {t(
                    'domain.mitarbeiter.create.steps.bezahlung.sollstunden.form.richtwertEinheit.options.stunden',
                  )}
                </span>
              </Toggle>
              <Toggle
                pressed={field.state.value === 'exakt'}
                onPressedChange={() => field.handleChange('exakt')}
                variant={'outline'}
                className="flex items-center justify-start gap-2 p-4 h-auto">
                <span>
                  {t(
                    'domain.mitarbeiter.create.steps.bezahlung.sollstunden.form.richtwertEinheit.options.exakt',
                  )}
                </span>
              </Toggle>
            </div>
          </FieldBase>
        )}
      </form.AppField>
    </div>
  );
}
